import React, { ChangeEvent, CSSProperties, useEffect, useRef, useState } from 'react'
import classes from './Service.module.css'
import './select-search.css'
import http from './../Service/http'
import { useTranslation } from 'react-i18next'

const SearchRole = ({
	changeIdStud,
	s_fio = '',
	style
}: {
	changeIdStud: (param: number) => void
	s_fio?: string
	style?: CSSProperties
}) => {
	const [text, setText] = useState({
		text: '',
		search: false
	})
	const search = useRef<HTMLInputElement>(null)
	const [students, setStudents] = useState<any[]>([])
	const { t } = useTranslation()

	const hundleText = (e: ChangeEvent<HTMLInputElement>) => {
		setText({
			text: e.target.value,
			search: true
		})
		changeIdStud(0)
	}

	const getStuds = async (param: string) => {
		const res = await http.get('/okno/avn_users?userName=' + param)
		setStudents(res.data.AVN_user_list)
	}

	useEffect(() => {
		if (text.search) getStuds(text.text)
	}, [text])
	useEffect(() => {
		setText({
			text: s_fio,
			search: false
		})

		const app = document.querySelector('.LayoutPage')
		if (app) {
			app.addEventListener('click', (e: any) => {
				if (e.target) {
					const searchWrap = e.target.closest('#search_list')
					if (!searchWrap) {
						setStudents([])
					}
				}
			})
		}
	}, [])

	return (
		<>
			<div style={style} className={classes.search} id='search_list'>
				<div style={{ position: 'relative', padding: '1px' }}>
					<input
						placeholder={t('st:other.choose')}
						ref={search}
						style={{ width: '100%', height: '100%', paddingLeft: '18px', fontSize: '13px' }}
						type='text'
						value={text.text}
						onInput={hundleText}
						onClick={e => {
							e.stopPropagation()
						}}
						className={classes.search_inp}
						onFocus={() => {
							setText({
								text: '',
								search: true
							})
							changeIdStud(0)
						}}
					/>
					{/* <IoIosArrowDown onClick={(e) => {
                        setStudents([]);
                        setText({
                            text: "",
                            search: true
                        })
                        changeIdStud(0)
                    }} style={{fontSize: "16px", color: "blue", position: 'absolute', top: '50%', right: '10px', zIndex: '3', transform: 'translateY(-50%)', cursor: 'pointer'}} /> */}
				</div>
				<div className={classes.list} style={{ width: '380px' }}>
					{students.map((item, i) => {
						return (
							<div
								key={i}
								onClick={async e => {
									await setText({
										text: item.t_fio,
										search: false
									})
									changeIdStud(item.id_teacher)
									setStudents([])
								}}
								className={classes.list_item}
							>
								<div className={classes.fio}>{item.t_fio}</div>
							</div>
						)
					})}
				</div>
			</div>
		</>
	)
}
export default SearchRole
